import { v4 as uuidv4 } from 'uuid'

import {
  addTrailer,
  approveTrailer,
  deleteTrailer,
  editTrailer,
  EquipmentStatus,
  fetchRemovedTrailers,
  missingTrailerFields,
  rejectTrailer,
  restoreTrailer,
  Trailer,
  TrailerClassLabels,
  TrailerCommonClasses,
} from '../models/equipment'
import { uploadTrailers } from '../models/insuranceApplication'
import { EquipmentTable, type EquipmentTableConfig } from './EquipmentTable'

export const trailerConfig: EquipmentTableConfig = {
  type: 'trailers',
  label: 'trailer',
  labelPlural: 'trailers',
  vehicleClasses: TrailerClassLabels,
  commonVehicleClasses: TrailerCommonClasses,
  makePlaceholder: 'Great Dane',
  modelPlaceholder: 'Everest',
  classFieldLabel: 'Trailer class',
  missingFields: missingTrailerFields,
  createEmpty: () => ({
    id: uuidv4(),
    vehicleNumber: '',
    telematicsId: '',
    vin: '',
    make: '',
    model: '',
    year: 0,
    licensePlate: '',
    licenseState: '',
    status: EquipmentStatus.ACTIVE,
    dateCreated: '',
    dateUpdated: '',
    vehicleClass: null,
    weightClass: null,
    price: null,
  }),
  upload: async (file: File, orgId: string) => {
    const { trailers, warning } = await uploadTrailers(orgId, file)
    return { items: trailers, warning }
  },
  uploadFieldColumns: [
    ['VIN', 'Make', 'Model', 'Year', 'Trailer class'],
    ['Registered state (optional)', 'License plate (optional)', 'Value (optional)'],
  ],
  apiAdd: (data, orgId) => addTrailer(orgId, data),
  apiEdit: (id, data, orgId) => editTrailer(orgId, id, data),
  apiDelete: (id, orgId) => deleteTrailer(orgId, id),
  apiFetchRemoved: (orgId) => fetchRemovedTrailers(orgId),
  apiRestore: (id, orgId) => restoreTrailer(orgId, id),
  apiApprove: (orgId, id) => approveTrailer(orgId, id),
  apiReject: (orgId, id) => rejectTrailer(orgId, id),
}

interface TrailersTableProps {
  trailers: Trailer[]
  setTrailers: (trailers: Trailer[]) => void
  handleSubmit?: (trailers: Trailer[]) => void
  footer?: React.ReactNode
  onDelete?: (trailer: Trailer) => void
  onEdit?: (trailer: Trailer) => void
  onAdd?: (trailer: Trailer) => void
  onRestore?: (trailer: Trailer) => void
  addCtaOnTop?: boolean
  readOnly?: boolean
  orgId: string
  hideHeading?: boolean
  heading?: string
  searchable?: boolean
  enforceCarrierRequired?: boolean
  compact?: boolean
  notice?: React.ReactNode
}

export function TrailersTable({ trailers, setTrailers, ...rest }: TrailersTableProps) {
  return <EquipmentTable items={trailers} setItems={setTrailers} config={trailerConfig} {...rest} />
}
